import {hitGoogleTagManager} from "../../tracking/google_tag_manager/init_google_tag_manager";

export const hitGtmFilterRoomsInBox = () => {
    hitGoogleTagManager({
        event: "GAEvent",
        GAEventCategory: "ui",
        GAEventAction: "filtry",
        GAEventLabel: "pokoje_kafel",
        GAEventNoInteraction: false
    });
};
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/init_google_tag_manager";

export const hitGtmFilterRoomsInBox = () => {
    hitGoogleTagManager({
        event: "GAEvent",
        GAEventCategory: "ui",
        GAEventAction: "filtry",
        GAEventLabel: "pokoje_kafel",
        GAEventNoInteraction: false
    });
};
